import { render, staticRenderFns } from "./px-label.vue?vue&type=template&id=4e109e3d&scoped=true&"
import script from "./px-label.vue?vue&type=script&lang=ts&"
export * from "./px-label.vue?vue&type=script&lang=ts&"
import style0 from "./px-label.vue?vue&type=style&index=0&id=4e109e3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e109e3d",
  null
  
)

export default component.exports